// Re-export regions.json as a module with proper typing
import data from './regions.json' with { type: 'json' };

const regionsData: GeoJSON.FeatureCollection = data as GeoJSON.FeatureCollection;
export default regionsData;
